import { React } from 'react';
import { Form, Image, Input } from 'antd';
import { Link } from 'react-router-dom';
import 'antd/dist/antd.css';
import style from './auth.module.scss';
import { CustomButton } from '../utils/Utils';
import axios from './../../config/apiConfig';
import { useParams } from 'react-router-dom';
import animatedLogo from './../../img/logo.gif';
import {
  FacebookOutlined,
  GlobalOutlined,
  InstagramOutlined,
} from '@ant-design/icons';

const ChangePass = () => {
  const {
    justifyCenter,
    justifyEnd,
    passInput,
    helpMargin,
    loginContainer,
    rememberPass
  } = style;
  const { token } = useParams();

  const onFinish = async (values) => {
    try {
      delete values.passRepeat;
      values.token = token;
      const { data } = await axios.post('/login/reset-password', values);
      console.log(data); // eslint-disable-line
    } catch (error) {
      console.log(error); // eslint-disable-line
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo); // eslint-disable-line
  };

  const pattern = '^[A-Za-z0-9-/_/-/ñ/Ñ]+$';

  const passConfirm = ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue('userPassword') === value) {
        return Promise.resolve();
      }
      return Promise.reject(
        new Error('¡Las contraseñas que ingresó no coinciden!'),
      );
    },
  });

  return (
    <>
      <div className={loginContainer}>
        <div>
          <div>
            <Image preview={false} src={animatedLogo} alt="" />
          </div>
          <div>
            <h1>BIENVENIDO/A EXPO SUIZA 2024</h1>
            <div>
              <Form
                labelCol={{
                  span: 7,
                }}
                name="basic"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <Form.Item
                  label=""
                  name="userPassword"
                  className={helpMargin}
                  rules={[
                    {
                      required: true,
                      message: 'Por favor escriba su contraseña',
                    },
                    {
                      min: 6,
                      message: 'Largo de contraseña mínimo 6 caracteres',
                    },
                    {
                      pattern: pattern,
                      message: 'los unicos simbolos permitidos son - y _',
                    },
                    {
                      max: 12,
                      message: 'Máximo de caracteres permitidos es 12',
                    },
                  ]}
                >
                  <Input.Password
                    placeholder="Nueva contraseña"
                    className={passInput}
                    maxLength="12"
                  />
                </Form.Item>
                <Form.Item
                  label=""
                  name="passRepeat"
                  className={helpMargin}
                  rules={[
                    {
                      required: true,
                      message: 'Por favor confirme la contraseña',
                    },
                    {
                      min: 6,
                      message: 'Largo de contraseña mínimo 6 caracteres',
                    },
                    {
                      max: 12,
                      message: 'Máximo de caracteres permitidos es 12',
                    },
                    passConfirm,
                  ]}
                >
                  <Input.Password
                    placeholder="Repita la contraseña"
                    className={passInput}
                    maxLength="12"
                  />
                </Form.Item>

                <Form.Item>
                  <Link to="/signPage" className={`${justifyCenter} ${rememberPass}`}>
                    ¡Ya recorde mi contraseña!
                  </Link>
                </Form.Item>

                <Form.Item>
                  <div className={justifyEnd}>
                    <CustomButton
                      htmlType="submit"
                      color="btnOrange"
                      size="bg"
                      content="Recuperar contraseña"
                    />
                  </div>
                </Form.Item>
              </Form>
            </div>
            <div>
              <a
                href="https://www.instagram.com/drogueriasuiza.ok/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramOutlined />
                /DROGUERIASUIZATUC
              </a>
              <a
                href="https://facebook.com/DROGUERIASUIZA"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookOutlined />
                /DROGUERIASUIZA
              </a>
              <a
                href="http://www.dsuiza.com.ar/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <GlobalOutlined />
                WWW.DSUIZA.COM.AR
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangePass;
